import { DatabaseSections } from "../../../enums/DatabaseEnums";
import ThreeComponentLayout from "../../../reusable-components/ThreeComponentLayout";
import { CustomTab } from "../../../Types/DatabaseTabTypes";
import DatabaseTab from "../../DatabaseTab";
import { useLocation } from "react-router-dom";
import OrdersTable from "./OrdersTable";
import DispatchDetails from "./DispatchDetails";
import JobDetails from "./JobDetails";
import { useEffect, useState } from "react";
import JobMapView from "./JobMapView";
import NonEditableMask from "../../../reusable-components/NonEditableMask";

const JobProfile = () => {
  const location = useLocation();
  const [isMasked, setIsMasked] = useState(location.state?.applyMask || false);
  const pathCustomerId = location?.pathname?.split("/")[3];
  const prependTabs: CustomTab[] = [
    {
      key: "ordersTable",
      label: "Order Details",
      children: (
        <OrdersTable
          section={DatabaseSections.JOBS}
          sectionId={pathCustomerId}
        />
      ),
    },
    {
      key: "dispatchDetails",
      label: "Dispatch Details",
      children: <DispatchDetails />,
    },
  ];
  useEffect(() => {}, [pathCustomerId]);

  return (
    <>
      <NonEditableMask isMasked={isMasked} />
      <ThreeComponentLayout
        topLeftWidthPercent={55}
        topLeft={<JobDetails sectionId={pathCustomerId} />}
        topRight={<JobMapView sectionId={pathCustomerId} />}
        bottom={
          <DatabaseTab
            isJob={true}
            section={DatabaseSections.JOBS}
            sectionId={pathCustomerId}
            prependTabs={prependTabs}
            blockedJob={location.state?.isBlocked}
          />
        }
      />
    </>
  );
};

export default JobProfile;
